<template>
    <Tile title="Blank Tile">
        <div class="blank-tile">This is an empty tile.</div>
    </Tile>
</template>

<script>
    import Tile from './Tile.vue';

    export default {
        components: {
            Tile,
        },
    }
</script>

<style scoped>
</style>